import React from 'react';

const PhFillBookmarkSimpleSvg = ({ size = 14 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden
  >
    <path d="M200,48V224a8,8,0,0,1-12.24,6.78L128,193.43,68.23,230.78A8,8,0,0,1,56,224V48A16,16,0,0,1,72,32H184A16,16,0,0,1,200,48Z" />
  </svg>
);

export default PhFillBookmarkSimpleSvg;
